import { Column } from '@simplywallst/ui-core';
import {
  PositionsContainerRow,
  PositionsContentRow,
  PositionsHeader,
  JobsContainer,
} from './styled';
import { OneColumnExpanded } from '../../styled';

interface Props {
  title?: string;
  subtitle?: string;
}

export const Positions = ({ title, subtitle }: Props) => {
  return (
    <PositionsContainerRow justifyContent="center">
      <OneColumnExpanded>
        <PositionsContentRow>
          <Column colMd={7}>
            <PositionsHeader data-cy-id="positions">
              <h2>{title}</h2>
              <p>{subtitle}</p>
            </PositionsHeader>
          </Column>
          <Column colMd={5}>
            <JobsContainer id="lever-jobs-container" />
          </Column>
        </PositionsContentRow>
      </OneColumnExpanded>
    </PositionsContainerRow>
  );
};
